export default "__VITE_ASSET__DeZgqZdH__"